import { Config } from '@backstage/config';

export function getFlag(config: Config, featureName: string): boolean {
  const featureFlags =
    config.getOptionalConfigArray('featureFlags.frontend') ?? [];
  const pluginFlag = featureFlags.find(
    flag => flag.getOptionalString('name') === featureName,
  );
  return pluginFlag?.getOptionalBoolean('enabled') ?? false;
}
